/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Color, FrontSide, RawShaderMaterial, Vector3, Vector4 } from 'three';

import { listen } from '@pkg/components/Sections/Profile/pubSub';
import { glUpdateTopic } from '@pkg/components/Sections/Profile/pubSub/constants';

import fragmentShader from './shaders/fragmentShader';
import vertexShader from './shaders/vertexShader';

export default class Material extends RawShaderMaterial {
    constructor(camera) {
        super({
            vertexShader,
            fragmentShader,
            side: FrontSide,
            transparent: true,
            uniforms: {
                time: { value: 0 },
                colorA: { value: new Color('rgb(255,	255,	255)') },
                colorB: { value: new Color('rgb(255,	255,	255)') },
                cameraPosition: { value: new Vector3() },
                cameraQuaternion: { value: new Vector4() },
                mousePosition: { value: new Vector3() },
                particleType: { value: 0 },
                particleTexture: { value: null },
                particleOpacity: { value: 0 },
                emitTime: { value: 0 },
            },
        });

        listen(glUpdateTopic, ({ elapsed }) => {
            this.uniforms.time.value = elapsed;
            this.uniforms.cameraPosition.value.copy(camera.position);
            this.uniforms.cameraQuaternion.value.copy(camera.quaternion);
        });
    }
}
